import { useStore } from './index';

/**
 * HEARTBEAT-IDENTITY — the latest server liveness beat (ISO) for a report
 * generation run, read from the root `generationHeartbeats` slice.
 *
 * The job worker re-stamps `heartbeatAt` on the job doc every ~30s for the
 * whole run (`HEARTBEAT_TICK_MS`). That beat deliberately does NOT live on the
 * run objects in `siteRag.activeGenerations`: carrying it there rebuilt every
 * run (and the slice) each tick and re-ran the site page's Path-to-GO memo
 * chain for a value only the stall indicators read. Subscribe here, per run,
 * from the component that renders the stall detector.
 */
export function useGenerationHeartbeat(runId: string | null | undefined): string | undefined {
  // Optional-chained on purpose: a store state replaced wholesale (persisted
  // simulations, test harnesses) may predate this slice.
  return useStore((s) => (runId ? s.generationHeartbeats?.[runId] : undefined));
}
